import { redirect, useRouteError } from "react-router-dom";
import "./styles.css";
import GenericErrorDisplay from "../../../generic-error";

import { path as exchangesPath } from "../page-exchanges/index.jsx";

export const path = "scope/";

export async function loader({ request }) {
  return redirect("../" + exchangesPath);
}

export function Component() {
  return <></>;
}
Component.displayName = "page-about-committees-scope";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-about-committees-scope-error";
